module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ch02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On her eighth birthday, Jael Thompson found out she wasn’t like other girls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have the name of an angel!” she boasted to her father after school at dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” said Paul Thompson. His hard, square-jawed face usually didn’t show much emotion. But at the word “angel,” his eyes went wide and he froze, his fork and knife in mid cut through his tamale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mrs. Perez says so,” said Jael. She bit down on a green bean and chewed as she said, “You know the Ark of the Covenant?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am … familiar,” he said. He went back to eating his tamale, but his eyes had a strangely intense look. Jael decided it meant he was fascinated by what she had to say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a big box that has the broken Ten Commandments of Moses in it,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, Daddy,” she said, trying her best to return the intense gaze he was giving her, “the lid of the box has two angels on it. Do you know what their names are?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("He blinked, then stared at her for a moment. “I don’t, actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She smiled triumphantly. “Their names are Zarall and "), _c('em', [_vm._v("Jael")]), _vm._v(". Can you believe that, Daddy? Can you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Amazing,” he said. His voice sounded mild, but a muscle in his jaw twitched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think angels are the coolest, Daddy. Especially Michael and Gabriel.” She frowned as she ate another green bean. “But Uriel is pretty cool too. He guards the Garden of Eden with his flaming sword. I think I’d like to have a flaming sword, Daddy. Don’t you think that would be cool, Daddy? To have a flaming sword? Daddy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um.” Her father’s expression was locked in a grimace, but Jael barely noticed. She was too busy showing off everything she’d learned about angels. It wasn’t every day that her father paid this much attention to what she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And there’s Azrael, of course,” she continued. “But he seems a little scary to me. And what about all those other angels? The ones that stay in Heaven all the time and never leave but just sing and sing and sing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jael—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know, Daddy, there’s seven levels of angels that don’t do anything but sing all the time, like infinity and "), _c('em', [_vm._v("forever")]), _vm._v(". Why is that, Daddy? Why do the angels have to sing all the time? Don’t they ever get tired?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jael, please stop talking about angels.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But they’re just so cool! And there’s all different kinds. Archangels, of course, Daddy. But also? There’s cherubim, and "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("seraphim, and ophanim, and you know you can pray to them? Pray to angels just like God, and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("“Enough!”")]), _vm._v(" Her father was on his feet, glaring down at her, angrier than she’d ever seen him. His wide shoulders went up and down with each breath. “Never speak of angels in this house again! "), _c('em', [_vm._v("Never!")]), _vm._v(" Is that understood?!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stared up at him for a moment. Then her eyes welled up with tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jael,” he said. “Don’t cry. Don’t …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She ran out of the apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("•  •  •")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Everything in Tucson was beige. The sidewalks, the streets, the houses—everything except the vast blue sky. Jael ran crying out the beige door, down the beige apartment building steps, and through the beige corridor that was her street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She didn’t run for long, though. It was late afternoon and the desert heat lay on her heavily, as if she were moving through a brick oven. She slowed down to a walk for the last block to the neighborhood playground. It was her favorite place, probably because it was the only place that wasn’t beige. The massive modern climbing structure was a blast of primary colors, with a red rock wall, a blue tire swing, and three swirling yellow slides. It was sheltered by a massive black mesh canopy that kept off the hard desert sun. Jael spent a lot of time at the playground, alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On this day when she came to the playground, it was different. A second structure stood off to the side. It didn’t fit in with the rest. The regular play structure was made of plastic and "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("painted metal, but this new contraption was made of a weird mix of wood, stone, and pitted iron. It looked old and not very safe, but Jael couldn’t resist something new to explore. She walked toward it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly, a sparrow dropped down from the sky and nearly hit her on the head. She gave a little yelp and swatted at it. It gave her a long, warbling chirp in response. Then it landed at the top of one of the yellow spiral slides. It cocked its head at her expectantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” she said. Like a lot of lonely kids, she had a habit of talking to animals. Sometimes she even talked to inanimate objects. “I’m just going to check out the new one first.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sparrow gave her another shrill chirp, then flew off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whatever,” she said, trying to make the word sound like it did when the older girls at her school said it. She walked purposefully toward the jumble of wood, stone, and iron.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As she started to climb up, sparkling brown eyes snapped open near her foot. Jael gave a little shriek and stumbled backward. The structure slowly began to shift and rise until it had reassembled into the shape of a giant ox. Jael started to back away carefully toward the playground exit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But then it spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Happy birthday,” it said in a slow, measured voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That made Jael stop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you know me?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It shook its massive stone head. “I knew your mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My mother?” she asked, her eyes going wide. Her father never spoke about her mother, other than to say that she died "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("when Jael was born. Whenever Jael asked about her, he only said they would talk about it when she was older. So Jael didn’t know anything about her, whether she was nice or mean, pretty or ugly, smart or dumb. Without any real facts, it was left to her imagination to conjure up her mother. She had imagined a thousand different mothers by this point, each more beautiful and perfect than the one before. A long line of angelic women who would one day swoop down and take her someplace safe, where everyone was kind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you know about my mother?” she asked the giant ox creature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was once a queen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No …,” said Jael. A thrill ran through her. Maybe one of her favorite imaginary mothers was the real thing. But she stopped herself. Even if it was magic, this thing was still a stranger. And sometimes strangers lied. He could be making it all up. “Oh yeah?” she said carefully. “Queen of what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The creature laughed so low and loud Jael could feel it in her chest. “Such a spitfire,” he said. “You are a lot like her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am?” said Jael, unable to keep the dreamy tone out of her voice. She moved a little closer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Certainly,” he said. “There was a time when we all admired her greatly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“‘We’?” asked Jael. “Are there other things like you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He cocked his massive square head to one side. “Oh,” he said. “You don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Know what?” she asked. “Who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can call me Baal. I was a servant of your uncle for a time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("“A servant?” she asked. Then, “I have an uncle?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared at her for a long time, not saying anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still in his measured monotone, he said, “This is disappointing. I had hoped to toy with you a little, halfbreed. But I think it would be lost on you. So I might as well just kill you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His brown eyes suddenly flared orange. His mouth stretched open, bits of stone and iron grinding within. Then he charged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jael stood frozen in terror, unable to move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Something small and feathered hit her on the head. The sparrow from before. That jolted her into action, and she dove to one side. Baal slammed into the playground structure, primary colors crunching down on him. He rose to his feet, tossing chunks of plastic and metal in all directions with his iron horns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jael scrambled to her feet and sprinted for the gate. It seemed impossibly far away and Baal was rapidly closing the gap.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t outrun me!” he said. “You’re mine, halfbreed!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not today, hellspawn!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The hard, clear voice echoed through the playground. Jael’s father stood at the entrance, his face calm. He hurled a small glass bottle over Jael’s head. It smashed into Baal’s face. Liquid sprayed out, and smoke rose up around his head. He gave a pained howl, then stumbled and fell.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jael’s father scooped her up and tossed her over his shoulder like a sack. He sprinted down the street to where the car was double-parked, the engine running. He tossed her into "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("the passenger seat and climbed in on his side. Then he gunned the engine, and the car tore down the street.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("•  •  •")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("They drove for hours on the highway across the desert plains, north toward Phoenix. The sun was setting red across the horizon when Jael finally found her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Daddy?” she asked. “What … was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A demon,” he said tersely. He kept his eyes on the road. “We stayed there too long. I knew it, but I just …” He shook his head. “We can’t make that mistake again. We got too comfortable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He said he knew Mom,” she said. “He said she was a queen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Demons will say anything to get you off your guard,” her father said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was she?” she asked. “A queen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I bet Mom would answer my questions,” she said. “I bet she’d be nice to me and she wouldn’t keep making me move to new places all the time, and yell at me for talking about angels. I wish she was here to take me away to her palace!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jael, your mother was a demoness.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It hung like that in silence for a long time. Her father still stared ahead at the road.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My … mom?” she asked finally. “Was a demon? Like that … "), _c('em', [_vm._v("thing")]), _vm._v(" back there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not exactly like Baal. She looked like a person, most of the time. But yes. She was a demoness.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("“But you said she died when I was born.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Demons can die too,” he said quietly. His eyes softened for a moment as he stared at the highway in front of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Was she … bad?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She tried to do good,” he said. Then his face hardened again. “And because of that, she made a lot of other demons very angry. If we stay in one place too long, demons might find us and kill us. That’s one reason we have to keep moving.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the other reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Because if we stay anywhere too long, normal people might figure out what you really are.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What am I?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your mother was a demon. That makes you half demon.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The desert plains flew by, receding on either side into the encroaching darkness. Jael felt like she was falling, even though she could still feel the car seat beneath her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Am "), _c('em', [_vm._v("I")]), _vm._v(" bad?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, of course not!” he said, finally turning to look at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can I still go to church?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” he said. “Jael, nothing has changed. You’re not any different. You just know more about yourself now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But won’t the priests get mad if they find out I’m a demon who goes to church?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“First, you’re only half demon. Second, they won’t find out. Because we will be very careful not to say anything. To anyone.” He turned and gave her a hard look. “Won’t we?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Daddy.” She was silent for a moment. Then, “Daddy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes?” His voice was beginning to sound strained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("“Am I … going to Hell?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, Jael,” he said. “I will do everything in my power to make sure that doesn’t happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Listen, this is all very complicated stuff that you’re not really old enough to understand. I am doing what’s best for us. For "), _c('em', [_vm._v("you")]), _vm._v(". All you need to do is trust me. Don’t worry about the rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do I at least have, you know … special powers?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” he snapped. “No powers, no horns, no nothing. You’re just like any other girl, but your mother was a demon. That’s it. No more questions. Is that clear?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, Daddy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They drove on like that for some time. Finally, her father took a deep breath. “Look, Jael. I’m sorry. I wish things weren’t so complicated. That we could just be normal people. But we just … can’t.” He drove on for a while longer. “If you want to talk about angels, that’s fine. You can do that. Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Jael didn’t respond. She didn’t know if she wanted to talk about angels anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the desert night settled in and the gleaming headlights cut through the emptiness all around them, it felt like the darkness would never lift.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And in a way, it never did. Her father never again spoke about her mother after that night. Occasionally, Jael would ask him questions, thinking she had to be old enough to hear the "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("answers by then. But every time, he would tell her there wasn’t much point in worrying about it, and to just do her best to be a good person.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once again, Jael’s imagination conjured up a thousand different mothers. But after that night, none of them were kind or angelic. None of them would swoop down and rescue her from this life. She understood that much, at least.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726606ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 78
// module chunks = 0